import EntryProductsList from './EntryProductsList';

export default EntryProductsList;
